{
  "selectCompanyStep": {
    "title": "Berätta lite mer",
    "description": "Hjälp oss att göra din Chirpee-upplevelse så smidig som möjligt",
    "companyInput": {
      "label": "Vad heter ditt företag?",
      "placeholder": "Ange företagsnamn"
    },
    "industryInput": {
      "label": "Företagsbransch",
      "placeholder": "Välj bransch"
    },
    "dataRegion": {
      "label": "Dataregion",
      "placeholder": "Välj dataregion",
      "tooltip": "Detta avgör var dina data lagras. Det kan inte ändras efter registrering.",
      "us": "USA",
      "eu": "Europeiska unionen"
    },
    "nextStepButton": "Nästa steg",
    "industries": {
      "technology": "Teknologi",
      "professionalServices": "Professionella tjänster",
      "financialServices": "Finansiella tjänster",
      "consulting": "Konsultverksamhet",
      "softwareDevelopment": "Programvaruutveckling",
      "digitalMarketing": "Digital marknadsföring",
      "mediaAndCommunications": "Media och kommunikation",
      "eCommerce": "E-handel",
      "healthTech": "Hälsoteknik"
    }
  },
  "selectLanguageStep": {
    "title": "Välj arbetsspråk",
    "description": "Välj språk som kommer att stödjas på din arbetsplats. Du kan redigera dem senare i arbetsplatsinställningarna"
  }
}
